module.exports = __webpack_public_path__ + "static/media/farmers-logo-dark.73c15721.svg";